import AsyncDialog from "./asyncDialog";

const $ = jQuery;

const RESULT_SUCCESS = "set";
const RESULT_CANCEL = "cancel";

function makeUi(dialog, imageUrl) {
    const msgDiv = $('<div>')
        .attr('title', "Insert Picture");
    const pAddress = $("<p>").text("Enter image URL:");
    const txtLinkedAddress = $('<input>').attr('class', 'linked-address').attr('id', 'txtLinkedAddress');

    if (imageUrl) {
        txtLinkedAddress.val(imageUrl);
    }

    msgDiv.append(pAddress.append(txtLinkedAddress))
        .append('<p class="info"><i>To remove the picture, delete all text from the URL field.</i></p>')
        .append($("<div class='buttons'>")
            .append(AsyncDialog.makeButton("OK", RESULT_SUCCESS))
            .append(AsyncDialog.makeButton("Cancel", RESULT_CANCEL)));

    msgDiv.on("click", ".ui-button", (e) => {
        const result = $(e.target).data('result');
        const data = txtLinkedAddress.val();

        dialog.closeWithResult({ result, data });
    });

    return msgDiv;
}

function showLinkedImageDialog(imageUrl) {
    const dialog = new AsyncDialog();
    const windowWidth = $(window).width();

    dialog.class = "fv-linked-image-dialog";
    dialog.width = Math.min(windowWidth, 700);
    dialog.setTarget(makeUi(dialog, imageUrl));

    return dialog.showAsync();
}

export {
    showLinkedImageDialog,
    RESULT_SUCCESS,
    RESULT_CANCEL,
}